<template>
  <v-row>
    <v-col cols="12">
      <h2>Apartments</h2>

    </v-col>

    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="developmentData.apartments"
          :search="search"
          item-key="name"
          class="elevation-1"
        >
          <template #item.quarantined="{ value }">
            <v-chip
              v-if="value > 0"
              color="#eb6b40"
              dark
            >
              {{value}}
            </v-chip>
          </template>
          <template #item.apartment_type="{ value }">
            <v-chip
              small
              v-if="value === 'lease'"
              color="#1867c0"
              dark
            >
              Lease
            </v-chip>
            <v-chip
              small
              v-else-if="value === 'sub-lease'"
              color="#5cbbf6"
              dark
            >
              Sub Lease
            </v-chip>
            <v-chip
              small
              v-else
              color="#bbb"
              dark
            >
              Empty
            </v-chip>

          </template>

        </v-data-table>
      </v-card>
    </v-col>


  </v-row>
</template>

<script>
import {get} from "vuex-pathify";

export default {
  name: "CreditBillingSingleApartments",
  computed: {
    developmentData: get('creditBilling/development'),
  },
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Apartment',
        align: 'start',
        value: 'name',
      },
      {text: 'Building', value: 'building_name'},
      {text: 'Meters', value: 'meters'},
      {text: 'Occupier', value: 'apartment_type'},
      {text: 'Occupier Reference', value: 'reference'},
      {text: 'Quarantined Meters', value: 'quarantined'},
    ],
  }),
  methods: {
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    }
  }
}
</script>

<style scoped>

</style>
